import { css, useTheme } from '@emotion/react'
import Image from 'next/image'
import clsx from 'clsx'
import { MediaQuery } from './Utility'

function Card({
    type = 'default',
    align = 'start',
    header,
    imgSrc,
    imgWidth = '500',
    imgHeight = '200',
    imgLayout = 'intrinsic',
    borderStyle = 'rounded',
    color,
    subtitle,
    horizentalImageSize,
    title,
    imgFullRound = false,
    children,
    bordered,
    className,
    shadow,
    spacing = 'lg',
    footer,
    style
}) {
    const theme = useTheme()
    const mainStyle = `
        background-color: ${color || theme.colors.white};
        ${shadow && `box-shadow: ${theme.boxShadow[shadow]}`};
        border-radius: ${switchBorderStyle(borderStyle)};
        ${bordered && `border: 1px solid ${theme.colors.lighterGray}`};
        padding: ${paddingSwitch(spacing)};
        ${style};
    `
    function switchBorderStyle(style) {
        switch (style) {
            case 'rounded':
                return theme.borderRadius.lg
            case 'square':
                return '0'
        }
    }
    function imageSizeSwitch(size) {
        switch (size) {
            case 'narrow':
                return '30%'
            case 'wide':
                return '100%'
            case 'normal':
                return '60%'
            default:
                return '60%'
        }
    }
    function paddingSwitch(space) {
        const spacing = theme.spacing
        switch (space) {
            case 'xs':
                return spacing.one
            case 'sm':
                return spacing.two
            case 'md':
                return spacing.four
            case 'lg':
                return spacing.six
            case 'xl':
                return spacing.eight
            case 'xxl':
                return spacing.ten
            default:
                return spacing.six
        }
    }
    return (
        <>
            {type === 'default' && (
                <div
                    className={clsx(
                        'card default-card vertical-card',
                        className
                    )}
                    css={css`
                        ${mainStyle}
                    `}
                >
                    {header && (
                        <div
                            className="px-10 py-2"
                            css={css`
                                display: flex;
                                align-items: center;
                            `}
                        >
                            {header}
                        </div>
                    )}
                    {imgSrc && (
                        <Image
                            priority={true}
                            src={imgSrc}
                            alt={title}
                            width={imgWidth}
                            height={imgHeight}
                            layout="responsive"
                            css={css`
                                object-fit: cover;
                                ${imgFullRound &&
                                (header
                                    ? 'border-radius: 0;'
                                    : /* eslint-disable indent */
                                      `border-radius: ${switchBorderStyle(
                                          borderStyle
                                      )};`)};
                                ${!imgFullRound &&
                                (header
                                    ? 'border-top-left-radius: 0; border-top-right-radius: 0;'
                                    : /* eslint-disable indent */
                                      `border-top-left-radius:${switchBorderStyle(
                                          borderStyle
                                      )}; 
                                      border-top-right-radius:${switchBorderStyle(
                                          borderStyle
                                      )};`)};

                                /* eslint-enable indent */
                            `}
                        />
                    )}

                    <div
                        className="container"
                        css={css`
                            padding: ${paddingSwitch(spacing)};
                            height: 100%;
                        `}
                    >
                        {subtitle && (
                            <div className="card-subtitle">{subtitle}</div>
                        )}
                        {title && (
                            <div className="card-title mt-2">{title}</div>
                        )}
                        {children && (
                            <div className="card-content h-full">
                                {children}
                            </div>
                        )}
                        {footer && (
                            <div
                                className="card-footer"
                                css={css`
                                    margin-top: 20px;
                                    display: flex;
                                `}
                            >
                                {footer}
                            </div>
                        )}
                    </div>
                </div>
            )}
            {type === 'horizental' && (
                <div
                    className={clsx('card horizental-card', className)}
                    css={css`
                        display: flex;
                        height: 100%;
                        ${align === 'start' && 'flex-direction: row'};
                        ${align === 'end' && 'flex-direction: row-reverse'};
                        ${mainStyle}
                    `}
                >
                    {imgSrc && (
                        <div
                            css={css`
                                width: ${imageSizeSwitch(horizentalImageSize)};
                                position: relative;
                                ${MediaQuery('md', 'max')} {
                                    width: ${imageSizeSwitch('normal')};
                                }
                                text-align: center;
                            `}
                        >
                            <Image
                                priority={true}
                                src={imgSrc}
                                alt={title}
                                layout={imgLayout}
                                width={imgWidth}
                                height={imgHeight}
                                css={css`
                                    object-fit: cover;
                                    ${
                                        '' /* ${!imgFullRound &&
                                    align === 'start' &&
                                    `border-top-right-radius: ${switchBorderStyle(
                                        borderStyle
                                    )};
                                border-bottom-right-radius: ${switchBorderStyle(
                                    borderStyle
                                )};`};
                                    ${!imgFullRound &&
                                    align === 'end' &&
                                    `border-top-left-radius: ${switchBorderStyle(
                                        borderStyle
                                    )};
                                border-bottom-left-radius: ${switchBorderStyle(
                                    borderStyle
                                )};`} */
                                    }
                                    ${imgFullRound &&
                                    `border-radius: ${switchBorderStyle(
                                        borderStyle
                                    )};`};
                                `}
                            />
                        </div>
                    )}

                    <div
                        className="container"
                        css={css`
                            height: 100%;
                        `}
                    >
                        {subtitle && (
                            <div className="card-subtitle px-4 my-2">
                                {subtitle}
                            </div>
                        )}
                        {title && (
                            <div className="card-title pt-1 px-4">{title}</div>
                        )}
                        {children && (
                            <div
                                className="card-content px-4 mt-2"
                                css={css`
                                    align-self: start;
                                `}
                            >
                                {children}
                            </div>
                        )}
                        {footer && (
                            <div
                                className="card-footer"
                                css={css`
                                    margin-top: 20px;
                                    display: flex;
                                `}
                            >
                                {footer}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    )
}

export default Card
